module.exports = __webpack_public_path__ + "img/delete_trash_white.bc84986b.svg";